export const baseUrl = "https://api.imigames.io:443/api/v1";

export const googleWebClientID = "356024293196-ma8od8hv9nuhrqiu3n7ms8cb4is7f8ck.apps.googleusercontent.com";

export const legalContracts = {
  termsCondUrl: "https://imigames.s3.ap-southeast-1.amazonaws.com/html_info/imi_app/terms_and_conditions/index.html",
  privacyPolicyUrl: "https://imigames.s3.ap-southeast-1.amazonaws.com/html_info/imi_app/privacy_policy/index.html",
};

export const DATA_KEY = "IMI_USER_DATA";

export const ImiPathsUrls = {
  init: "/init/:id",
  home: "/home",
  game: "/game",
  search: "/search",
  profile: "/profile",
  subs: "/profile/subs",
};

export const ImiCategoryTypes = {
  PROMO_GAME: "PROMO_GAME",
  GAME: "GAME",
  VIDEO: "VIDEO",
  IMAGE: "IMAGE",
  BETA_GAME: "BETA_GAME",
  UNKNOWN: "UNKNOWN",
};

export const IMIThemeMode = {
  LIGHT: "light",
  DARK: "dark",
};

export const SubScreens = {
  MY_SUBS: "my subscriptions",
  IN_GAME_LOGIN: "in game login",
};

export const isUnderMaintenance = true;
